export default __webpack_public_path__ + "static/419058397-capace_800x780-83a4e51a23a60c5ef470fb451773f250.jpg";